import axios from "axios";

import { VITE_LOCAL_BACKEND_URL } from "../ENV.ts";
import { authorizationToken } from "../utils/session/authorizationToken";
import { isNewAuthorization, useAuthorizationStore } from "../store/authorizationStore";

export const axiosInstance = axios.create({
  baseURL: VITE_LOCAL_BACKEND_URL || "/api",
  timeout: 30000,
  headers: {
    "X-Channel-Id": "web",
  },
});

const requestEpochs = new WeakMap<object, number>();

axiosInstance.interceptors.request.use((config) => {
  if (isNewAuthorization()) {
    requestEpochs.set(config, useAuthorizationStore.getState().epoch);
  }

  const token = authorizationToken();

  // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
  config.headers = config.headers ?? {};
  (config.headers as Record<string, string | undefined>).Authorization = token ? `Bearer ${token}` : undefined;

  return config;
});

axiosInstance.interceptors.response.use((response) => {
  const epoch = requestEpochs.get(response.config);

  if (epoch !== undefined && epoch !== useAuthorizationStore.getState().epoch) {
    throw new Error("Session changed");
  }

  return response;
});
